// extracted by mini-css-extract-plugin
module.exports = {"label":"LocationDropdown-module__label___1orSG","counter":"LocationDropdown-module__counter___13cUP","regionName":"LocationDropdown-module__regionName___23NE-"};